import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import {AiPrompt, AiPromptUsage} from 'app/Model/aiprompt';
import { lastValueFrom } from 'rxjs';
import {NextPimField} from "../Model/Catalog/NextPimField";

@Injectable()
export class AiPromptsService {
  private readonly apiUrl = 'api/aiprompt';
  public onChange = new EventEmitter<AiPrompt[]>();

  constructor(private http: HttpClient) {}

  public get(id: string, customerId: string): Promise<AiPrompt> {
    const url = `${this.apiUrl}/get`;
    const params = new HttpParams().append('id', id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<AiPrompt>(url, options));
  }

  public getAll(customerId: string): Promise<AiPrompt[]> {
    const url = `${this.apiUrl}/getAll`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<AiPrompt[]>(url, options));
  }

    public getAllForSpecificType(customerId: string, promptType:AiPromptUsage): Promise<AiPrompt[]> {
        const url = `${this.apiUrl}/getAllForSpecificType`;
        const params = new HttpParams().append('customerId', customerId).append('promptType', promptType);
        const options = { params };
        return lastValueFrom(this.http.get<AiPrompt[]>(url, options));
    }

  public create(model: AiPrompt, customerId: string): Promise<AiPrompt> {
    const url = `${this.apiUrl}/create`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.post<AiPrompt>(url, model, options));
  }

  public update(model: AiPrompt, customerId: string): Promise<AiPrompt> {
    const url = `${this.apiUrl}/update`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.post<AiPrompt>(url, model, options));
  }

  public delete(id: string, customerId: string): Promise<AiPrompt> {
    const url = `${this.apiUrl}/delete`;
    const params = new HttpParams().append('id', id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.delete<AiPrompt>(url, options));
  }

  public getModels(customerId: string): Promise<{ model: string; provider: string; isSystemProvided: boolean }[]> {
    const url = `${this.apiUrl}/getModels`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<{ model: string; provider: string; isSystemProvided: boolean }[]>(url, options));
  }
  public getFieldsWithGroups(customerId: string): Promise<{field:  string, groupp: string}[]> {
    const url = `${this.apiUrl}/getFieldsWithGroups`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<{field:  string, groupp: string}[]>(url, options));
  }

  public usePrompt(aiPrompt: AiPrompt, productId: string, customerId: string): Promise<{ result: string }> {
    const url = `${this.apiUrl}/usePrompt`;
    const params = new HttpParams().append('customerId', customerId).append('productId', productId);
    const options = { params };
    return lastValueFrom(this.http.post<{ result: string }>(url, aiPrompt, options));
  }

  public applyPromptResult(promptResult: string, targetField: string, productId: string, customerId: string, nextPimTargetFields: NextPimField []): Promise<object> {
    const url = `${this.apiUrl}/applyPromptResult`;
    const params = new HttpParams().append('customerId', customerId).append('productId', productId).append('targetField', targetField).append('promptResult', promptResult);
    const options = { params };
    return lastValueFrom(this.http.post(url, nextPimTargetFields, options));
  }



  public copyPrompt(customerId: string, templateId: string, targetCustomerId): Promise<boolean> {  

    const url = `${this.apiUrl}/copyPrompt`;
    const params = new HttpParams().append('customerId', customerId)
      .append('targetCustomerId', targetCustomerId)
      .append('templateId', templateId)
      ;
    const options = { params };
    return lastValueFrom(this.http.post<boolean>(url, null, options));

  
  }
}
